// Mock seed data for BNI Davangere Members Day 2026

export const CATEGORIES = [
  "IT & Software",
  "Manufacturing & Textiles",
  "Healthcare",
  "Finance & Insurance",
  "Real Estate & Construction",
  "Retail & Distribution",
  "Hospitality & Events",
  "Professional Services",
  "Education",
  "Automotive",
];

export const CHAPTERS = [
  { name: "Jal", region: "Davangere" },
  { name: "Agni", region: "Davangere" },
  { name: "Vayu", region: "Davangere" },
  { name: "Prithvi", region: "Davangere" },
  { name: "Bengaluru Central", region: "Bengaluru" },
  { name: "Hubballi Titans", region: "Hubballi" },
  { name: "Mysuru Prime", region: "Mysuru" },
  { name: "Chennai Anna", region: "Chennai" },
  { name: "Hyderabad Nizam", region: "Hyderabad" },
  { name: "Dubai Delta", region: "Dubai" },
  { name: "Singapore Marina", region: "Singapore" },
  { name: "UK London", region: "United Kingdom" },
];

export const TIERS = [
  { id: "region",  name: "Davangere Region Member", fee: 1499, desc: "Local chapter members" },
  { id: "visit",   name: "Visiting Member",         fee: 2499, desc: "Other cities & states" },
  { id: "intl",    name: "International Delegate",  fee: 4999, desc: "Includes travel & stay note" },
  { id: "guest",   name: "Guest",                   fee: 999,  desc: "By member invitation" },
];

export const STALL_TIERS = [
  { id: "s33",  name: "Standard Stall (3×3 m)", fee: 12000 },
  { id: "s63",  name: "Premium Stall (6×3 m)",  fee: 22000 },
  { id: "s66",  name: "Pavilion (6×6 m)",       fee: 42000 },
];

export const MEAL_WINDOWS = [
  { id: "bkfst", name: "Breakfast", start: "07:30", end: "09:00", grace: 15 },
  { id: "lunch", name: "Lunch",     start: "13:00", end: "14:15", grace: 15 },
  { id: "tea",   name: "High Tea",  start: "16:00", end: "16:45", grace: 10 },
];

// Deterministic pseudo-random helpers
function mulberry32(a) {
  return function() {
    let t = a += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}
const rand = mulberry32(20260226);
const pick = (arr) => arr[Math.floor(rand() * arr.length)];

const FIRST = ["Rajesh","Priya","Arun","Vikram","Deepa","Suresh","Anjali","Karthik","Meena","Ravi","Kavya","Naveen","Lakshmi","Prakash","Sneha","Ganesh","Divya","Manoj","Pooja","Harish","Aishwarya","Sanjay","Nisha","Ramesh","Shweta","Ajay","Bhavna","Rohan","Kiran","Ashok","Farhan","Neeraj","Sushmita","Vivek","Tanvi","Yash","Chaitra","Mohit","Riya","Aditya","Isha","Sameer","Nithya","Varun","Preeti","Tarun","Sonia","Rakesh","Anita","Girish"];
const LAST = ["Patil","Sharma","Kumar","Sethi","Reddy","Nair","Kulkarni","Iyer","Rao","Shetty","Bhat","Hegde","Menon","Gowda","Naidu","Verma","Agarwal","Joshi","Deshpande","Malhotra","Chandra","Pillai","Krishnan","Prabhu","Achar","Mehta"];

const AVATAR_POOL = [
  "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1552058544-f2b08422138a?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1554151228-14d9def656e4?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=200&h=200&fit=crop&crop=faces",
  "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=200&h=200&fit=crop&crop=faces",
];

function padId(n) { return String(n).padStart(4, "0"); }

// Generate ~300 members
export const MEMBERS = (() => {
  const list = [];
  for (let i = 1; i <= 300; i++) {
    const first = FIRST[Math.floor(rand()*FIRST.length)];
    const last  = LAST[Math.floor(rand()*LAST.length)];
    const chapter = pick(CHAPTERS);
    const tier = chapter.region === "Davangere" ? TIERS[0] :
                 (chapter.region === "Dubai" || chapter.region === "Singapore" || chapter.region === "United Kingdom") ? TIERS[2] :
                 (rand() > 0.85 ? TIERS[3] : TIERS[1]);
    const cat = pick(CATEGORIES);
    list.push({
      id: `BNI-DVG-${padId(1000 + i)}`,
      name: `${first} ${last}`,
      phone: `+91 9${Math.floor(rand()*900000000+100000000)}`,
      email: `${first.toLowerCase()}.${last.toLowerCase()}@bni-demo.in`,
      chapter: chapter.name,
      region: chapter.region,
      category: cat,
      interests: [pick(CATEGORIES), pick(CATEGORIES), pick(CATEGORIES)].filter((v,i,a)=>a.indexOf(v)===i),
      tier: tier.id,
      tierName: tier.name,
      fee: tier.fee,
      avatar: AVATAR_POOL[i % AVATAR_POOL.length],
      paid: rand() > 0.08,
      cancelled: rand() > 0.97,
    });
  }
  return list;
})();

// Assemble 50 tables x 4 rounds, seating 6 per table => 300 members reshuffled per round.
export const TABLES_COUNT = 50;
export const ROUNDS = [
  { id: 1, label: "Round 1", time: "11:15 AM" },
  { id: 2, label: "Round 2", time: "02:15 PM" },
  { id: 3, label: "Round 3", time: "03:30 PM" },
  { id: 4, label: "Round 4", time: "04:45 PM" },
];

// Simple shuffle per round
function shuffled(arr, seed) {
  const r = mulberry32(seed);
  const a = arr.slice();
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(r() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export const SEATING = (() => {
  const rounds = {};
  ROUNDS.forEach((r) => {
    const shuffledMembers = shuffled(MEMBERS, 100 + r.id);
    const tables = [];
    for (let t = 0; t < TABLES_COUNT; t++) {
      const seats = shuffledMembers.slice(t*6, t*6+6).map((m, idx) => ({ memberId: m.id, seat: idx }));
      tables.push({ tableNo: t + 1, seats });
    }
    rounds[r.id] = tables;
  });
  return rounds;
})();

// Pre-seeded referrals (~180) — recent-first
export const INITIAL_REFERRALS = (() => {
  const items = [];
  const now = Date.now();
  for (let i = 0; i < 180; i++) {
    const round = 1 + Math.floor(rand() * 4);
    const table = 1 + Math.floor(rand() * TABLES_COUNT);
    const tSeats = SEATING[round][table - 1].seats;
    const from = tSeats[Math.floor(rand() * tSeats.length)].memberId;
    let to = tSeats[Math.floor(rand() * tSeats.length)].memberId;
    if (from === to) to = tSeats[(tSeats.findIndex(s=>s.memberId===from)+1) % tSeats.length].memberId;
    const count = 1 + Math.floor(rand() * 3);
    const value = [15000, 25000, 50000, 75000, 125000, 200000][Math.floor(rand()*6)];
    items.push({
      id: `REF-${padId(i+1)}`,
      round, table,
      from, to,
      count, value,
      type: ["referral","business","121"][Math.floor(rand()*3)],
      ts: now - Math.floor(rand() * 5 * 60 * 60 * 1000),
    });
  }
  return items.sort((a,b)=>b.ts-a.ts);
})();

// Sample funnel numbers for admin
export const FUNNEL = { visits: 4820, started: 2140, paid: 1841, cancelled: 96 };

export const REGISTRATION_TARGET = 2000;

export const WA_TEMPLATES = [
  { id: "wa-conf",  name: "Registration Confirmation", sent: 1841, delivered: 1802, read: 1520, failed: 39 },
  { id: "wa-qr",    name: "QR Code Pass",              sent: 1841, delivered: 1798, read: 1421, failed: 43 },
  { id: "wa-alert", name: "Conclave Table Alert",      sent: 1420, delivered: 1401, read: 1150, failed: 19 },
  { id: "wa-meal",  name: "Meal Voucher",              sent:  822, delivered:  810, read:  601, failed: 12 },
];

export const INTEGRATIONS = [
  { id: "razorpay", name: "Razorpay",          key: "rzp_live_••••••••••8842", status: "connected" },
  { id: "wa",       name: "WhatsApp Business", key: "eaab_••••••••••9921",     status: "connected" },
  { id: "twilio",   name: "Twilio SMS",        key: "SK_••••••••••••7710",     status: "connected" },
  { id: "s3",       name: "AWS S3 (Assets)",   key: "AKIA_••••••••••Q7A2",     status: "connected" },
];

export const SPONSORS = [
  { id: "s1", name: "Trishul Group",       tier: "TITLE",     tagline: "Presenting Sponsor",          color: "#CC252F" },
  { id: "s2", name: "Karnataka Bank",      tier: "PLATINUM",  tagline: "Banking Partner",              color: "#E23E47" },
  { id: "s3", name: "Vidyanagara Motors",  tier: "PLATINUM",  tagline: "Mobility Partner",             color: "#E0A526" },
  { id: "s4", name: "Suvarna Textiles",    tier: "GOLD",      tagline: "Retail Partner",               color: "#3FBF7F" },
  { id: "s5", name: "Bapuji Diagnostics",  tier: "GOLD",      tagline: "Wellness Partner",             color: "#3B82F6" },
  { id: "s6", name: "Basavakalyan Foods",  tier: "SILVER",    tagline: "Hospitality Partner",          color: "#8B8378" },
  { id: "s7", name: "Chandra Constructions", tier: "SILVER",  tagline: "Venue Partner",                color: "#E23E47" },
  { id: "s8", name: "Neelavara IT Systems", tier: "GOLD",     tagline: "Technology Partner",           color: "#3B82F6" },
];

export const findMember = (id) => MEMBERS.find((m) => m.id === id);

// Utility for demo — the "current" member (used in Member Portal after mock OTP)
export const CURRENT_MEMBER_ID = MEMBERS[0].id;
